import styled from "styled-components";
import {Typography} from 'antd';
const AntParagraph = Typography.Paragraph;

export const Paragraph = styled(AntParagraph)`
  color: #ffffff;
`